import { useQuery } from "@tanstack/react-query";
import { getReportRevenue } from "../../api/apiReports";

export const useGetReportRevenue = (params) => {
    const { data, isLoading, error, refetch } = useQuery({
        queryKey: ["report-revenue", params],
        queryFn: () => getReportRevenue(params),
        retry: false,
    });

    return {
        series: data?.data || [],
        isLoading,
        error,
        refetch,
    };
};
